const SchedulePopup = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg w-full max-w-6xl max-h-[90vh] overflow-hidden shadow-2xl">
        <div className="flex items-center justify-between p-4">
          <h2 className="text-xl font-bold text-[#006719]">LỊCH THI ĐẤU</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 bg-[#006719] text-white rounded-full flex items-center justify-center hover:bg-[#004d12] transition-colors"
          >
            x
          </button>
        </div>

        <div className="p-4">
          <iframe
            src="https://football-widget.pages.dev/"
            width="100%"
            height="600"
            frameBorder="0"
            allowFullScreen
            title="Football Widget"
            className="w-full rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default SchedulePopup;

